import React, { useState, useEffect } from "react";
import { Text } from "../text";
import { defaultStyles } from "../../../constants/style-constants/utils";
import * as Style from "./styles/form-header";
import useActiveTabs from "../../../hooks/active-tabs";

function FormHeader({
  headerData,
  setActiveTabData,
  activeTabData,
  activeTabsArray,
  handleActiveTabsArray,
  handleTabClick
}) {
  useEffect(() => {}, []);
  console.log("headerData", headerData);
  console.log("activeTabsArray", activeTabsArray);

  const headerDataLength = Object.values(headerData).length;

  return (
    <>
      <Style.HeaderContainer>
        <div
          style={{
            // width: "80%",
            margin: "-1% 3% 0 0",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}>
          {headerData &&
            Object.values(headerData).map((item, index) => (
              <Style.MainContainer key={index + 1}>
                <Style.SubContainer>
                  <Style.Circle
                  onClick={() => handleTabClick(item.name)}
                    style={{
                      border:
                        activeTabsArray && activeTabsArray.includes(item.name)
                          ? ""
                          : "2px solid #e0e0e0",
                    }}
                    backgroundColor={
                      activeTabsArray && activeTabsArray.includes(item.name)
                        ? "#2A3DA3"
                        : ""
                    }>
                    <p
                      style={{
                        color:
                          activeTabsArray && activeTabsArray.includes(item.name)
                            ? "#fff"
                            : "#2A3DA3",
                        fontSize: "24px",
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                      }}>
                      {index + 1}
                    </p>
                  </Style.Circle>
                  {headerDataLength == index + 1 ? null : (
                    <Style.Line
                      style={{
                        backgroundColor:
                          activeTabsArray && activeTabsArray.includes(item.name)
                            ? "#2A3DA3"
                            : "",
                      }}></Style.Line>
                  )}
                  {/* <Style.Line></Style.Line> */}
                </Style.SubContainer>
                <p
                  style={{
                    textAlign: "left",
                    color: "#000000",
                    position: "absolute",
                    width: "74px",
                    top: "40px",
                    left: "-5px",
                    textAlign: "center",
                  }}>
                  {item.title}
                </p>
                {/* <div style={{ width: "6rem" }}> */}
                {/* <Text color="#9bc5b1">{item.title}</Text> */}
                {/* </div> */}
              </Style.MainContainer>
            ))}
        </div>
      </Style.HeaderContainer>
    </>
  );
}

export default FormHeader;
